/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_DiscardingInputs */

const en_case_discarding = /** @type {(inputs: Case_DiscardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discarding…`)
};

const pt_br2_case_discarding = /** @type {(inputs: Case_DiscardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartando…`)
};

/**
* | output |
* | --- |
* | "Discarding…" |
*
* @param {Case_DiscardingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_discarding = /** @type {((inputs?: Case_DiscardingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_DiscardingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_discarding(inputs)
	return pt_br2_case_discarding(inputs)
});